import { elmElementExists } from 'elm/utilities'
import * as CreateDepotCard from 'elm/initializers/create_depot_card'
import * as Feedback from 'elm/initializers/feedback'
import * as Events from 'elm/initializers/events'
import * as Roles from 'elm/initializers/roles'
import * as ManageRoles from 'elm/initializers/manage_roles'
import * as SegmentMapContainer from 'elm/initializers/segment_map_container'
import * as GeoMapContainer from 'elm/initializers/geo_map_container'
import * as GeoPieMapContainer from 'elm/initializers/geo_pie_map_container'

export default function init (): void {
  if (elmElementExists('CreateDepotCard')) CreateDepotCard.init()
  if (elmElementExists('Feedback')) Feedback.init()
  if (elmElementExists('Events')) Events.init()
  if (elmElementExists('Roles')) Roles.init()
  if (elmElementExists('ManageRoles')) ManageRoles.init()
  if (elmElementExists('SegmentMapContainer')) SegmentMapContainer.init()
  if (elmElementExists('GeoMapContainer')) GeoMapContainer.init()
  if (elmElementExists('GeoPieMap.Container')) GeoPieMapContainer.init()
}
